import { fromJS } from 'immutable';
import { actions } from 'react/api/actions/ticketHub';

const initialState = fromJS({
  isLoading: true,
  all: [],
  isOpen: false
});

export default (state = initialState, action) => {
  switch (action.type) {
    case actions.setLoading:
      return state.set('isLoading', action.payload);
    case actions.setTicketsToState:
      return state.set('all', fromJS(action.payload.tickets));
    case actions.toggleHub:
      return state.set('isOpen', action.payload);
    case actions.updateTicketAccepted: {
      const { ticketId, userLogged } = action.payload;
      const today = new Date();
      const tickets = state.get('all');
      const ticketToUpdateIndex = tickets.findIndex((ticket) => ticket.get('id') === ticketId);

      return ticketToUpdateIndex > -1 ? state.updateIn(['all', ticketToUpdateIndex], (ticket) => {
        let ticketChanged;
        ticketChanged = ticket.set('ticketStatus', 'ASSIGNED');
        ticketChanged = ticketChanged.set('whenStatusChanged', today);
        ticketChanged = ticketChanged.set('userAssigned', fromJS(userLogged));

        return ticketChanged;
      }) : state;
    }
    case actions.updateTicketStatus: {
      const { ticketId, status } = action.payload;
      const tickets = state.get('all');
      const ticketToUpdateIndex = tickets
        .findIndex((ticket) => ticket.get('id') === ticketId);

      return ticketToUpdateIndex > -1 ? state.updateIn(['all', ticketToUpdateIndex],
        (ticket) => ticket.set('ticketStatus', status))
        : state;
    }
    default:
      return state;
  }
};
